export default __webpack_public_path__ + "static/media/Peter-Glechikov.54a28f85.png";